export type PowerSetpointType = 'charging' | 'discharging' | 'idle';

export function getPowerSetpointType(powerSetpoint: number): PowerSetpointType {
  if (powerSetpoint < 0) return 'charging';
  if (powerSetpoint > 0) return 'discharging';
  return 'idle';
}

export const POWER_SETPOINT_COLORS = {
  charging: {
    border: 'border-[#038BA8]',
    bg: 'bg-[#038BA8]/20',
    bgHover: 'hover:bg-[#038BA8]/30',
    text: 'text-[#038BA8]',
    label: 'Charging',
    dot: 'bg-[#038BA8]',
  },
  discharging: {
    border: 'border-[#AC44FB]',
    bg: 'bg-[#AC44FB]/20',
    bgHover: 'hover:bg-[#AC44FB]/30',
    text: 'text-[#AC44FB]',
    label: 'Discharging',
    dot: 'bg-[#AC44FB]',
  },
  idle: {
    border: 'border-slate-400',
    bg: 'bg-slate-200',
    bgHover: 'hover:bg-slate-300',
    text: 'text-slate-700',
    label: 'Idle',
    dot: 'bg-slate-400',
  },
} as const;

export type TimeSlotStatus = 'active' | 'inactive' | 'expired';

export function getTimeSlotStatus(
  slot: { isActive?: boolean; validUntil?: string | null },
  now: number = Date.now()
): TimeSlotStatus {
  if (slot.validUntil) {
    const expiresAt = new Date(slot.validUntil).getTime();
    if (!Number.isNaN(expiresAt) && expiresAt < now) return 'expired';
  }
  if (slot.isActive === false) return 'inactive';
  return 'active';
}

export const TIME_SLOT_STATUS_STYLES = {
  active: {
    container: 'opacity-90',
    label: null,
    hatch: false,
  },
  inactive: {
    container: 'opacity-40 grayscale border-dashed',
    label: 'Inactive',
    hatch: false,
  },
  expired: {
    container: 'opacity-60 grayscale border-dashed',
    label: 'Expired',
    hatch: true,
  },
} as const satisfies Record<
  TimeSlotStatus,
  { container: string; label: string | null; hatch: boolean }
>;
